export default function DealerAvatar(props) {
  return (
    <svg width='76' height='76' viewBox='0 0 76 76' {...props}>
      <g id='Group_845' data-name='Group 845' transform='translate(-1469 -700)'>
        <circle
          id='adea4e335ac1aa9ef7901173c00c528a'
          cx='38'
          cy='38'
          r='38'
          transform='translate(1469 700)'
          fill='#e9ecf2'
        />
        <g id='Group_839' data-name='Group 839' transform='translate(21832.043 24147.682)'>
          <path
            id='car'
            d='M29.116,9.524,27.008,3.162A4.64,4.64,0,0,0,22.61,0H8.433A4.543,4.543,0,0,0,5.725.872a4.5,4.5,0,0,0-1.69,2.29L1.927,9.524A3.28,3.28,0,0,0,.545,10.651,2.926,2.926,0,0,0,0,12.4v7.743a2.957,2.957,0,0,0,.436,1.581,3.183,3.183,0,0,0,1.127,1.109v3.526a1.551,1.551,0,0,0,1.563,1.563H4.653a1.551,1.551,0,0,0,1.563-1.563v-3.09H24.827v3.09a1.551,1.551,0,0,0,1.563,1.563h1.527a1.551,1.551,0,0,0,1.563-1.563V22.828a3.183,3.183,0,0,0,1.127-1.109,2.957,2.957,0,0,0,.436-1.581V12.4a2.926,2.926,0,0,0-.545-1.745A3.28,3.28,0,0,0,29.116,9.524ZM8.433,3.09h14.14a1.587,1.587,0,0,1,.927.291,1.416,1.416,0,0,1,.563.763l1.708,5.162H5.271L6.979,4.144a1.416,1.416,0,0,1,.563-.763A1.532,1.532,0,0,1,8.433,3.09ZM5.453,18.611A2.218,2.218,0,0,1,3.8,17.921a2.317,2.317,0,0,1,1.654-3.962,2.266,2.266,0,0,1,1.636.672,2.3,2.3,0,0,1,0,3.29A2.236,2.236,0,0,1,5.453,18.611Zm20.138,0a2.326,2.326,0,0,1-1.636-3.98,2.326,2.326,0,0,1,3.29,3.29A2.218,2.218,0,0,1,25.59,18.611Z'
            transform='translate(-20340.789 -23431)'
            fill='#0e77ef'
          />
          <path
            id='hand_holding_heart'
            data-name='hand holding heart'
            d='M41.076,31.81A2.254,2.254,0,0,1,41,35.372l-10.978,8.8a4.623,4.623,0,0,1-2.908,1.018H1.163A1.12,1.12,0,0,1,0,44.024V37.044a1.12,1.12,0,0,1,1.163-1.163h4l3.417-2.763a8.284,8.284,0,0,1,5.38-1.89H25.59a2.2,2.2,0,0,1,1.781.836,2.294,2.294,0,0,1,.545,1.854,2.161,2.161,0,0,1-.872,1.418,2.606,2.606,0,0,1-1.6.545H19.774a1.164,1.164,0,1,0,0,2.326h8.579a4.434,4.434,0,0,0,2.908-1.018l6.761-5.38a2.295,2.295,0,0,1,3.053,0Zm.8,8.724'
            transform='translate(-20346 -23433.549)'
            fill='#0e77ef'
          />
        </g>
      </g>
    </svg>
  )
}
